<template>

    <div>

        <div class="px-6 py-4 bg-minplan-beige -mb-4">
            <page-title :title="$t('templates.renameTemplate')"></page-title>
        </div>

        <jet-form-section @submitted="update()">

            <template #form>

                <form-card :title="$t('templates.template')" :description="$t('templates.templateDescription')">
                    <div class="col-span-6">
                        <label for="name" class="block text-sm font-medium text-gray-700">{{
                                $t("templates.name")
                            }} <RequiredMark /></label>
                        <input type="text" name="name" id="name" v-model="form.name"
                               class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                               autofocus />
                        <jet-input-error :message="form.errors.name" class="mt-2" />
                    </div>

                </form-card>

            </template>

            <template #actions>
                <div class="flex justify-end my-4 mx-6">

                    <button @click="cancel" type="button" class="inline-block uppercase font-semibold text-xs tracking-widest">{{ $t('actions.cancel') }}</button>

                    <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3">
                        {{ $t("actions.save") }}
                    </primary-button>

                </div>
            </template>

        </jet-form-section>
    </div>
</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import { useForm } from "@inertiajs/inertia-vue3";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";
import RequiredMark from "@/Shared/Components/RequiredMark";

export default defineComponent({
    props: ['template'],
    layout: MainLayout,
    inheritAttrs: false,
    emits: ["closeModal"],
    components: {
        PageTitle,
        FormCard,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        RequiredMark
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        update() {
            this.form.put(this.route("advisors.templates.update", this.template.uuid), {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: "actions.success",
                    text: "templates.updated"
                })
            });
        }
    },
    setup(props) {
        const form = useForm({
            name: props.template.name
        });

        return { form };
    }
});
</script>

<style scoped></style>
